import { ShipInfo } from '@ais-ui/websockets';
import React from 'react';
import { BaseInformation } from './ShipDetailsTabs/BaseInformation';
import { IntegrityInformation } from './ShipDetailsTabs/IntegrityInformation';
import { RegisterInformation } from './ShipDetailsTabs/RegisterInformation';
import { AdvancedVesselInformation } from './ShipDetailsTabs/AdvancedVesselInformation';
import { TargetTab } from './targetTypes';
import { NextPortPanel } from './ShipDetailsTabs/NextPortPanel';
import { useViewMode, ViewMode } from '../../components/ViewModeProvider';

interface ShipComponentProps {
  shipInfo: ShipInfo;
  tab: TargetTab;
}

// Component that uses map context - only rendered when NOT in detail view
const MapViewShipDetailsPanel = ({ shipInfo, tab }: ShipComponentProps) => {
  if (tab === 'base') {
    return <BaseInformation shipInfo={shipInfo} />;
  } else if (tab === 'integrity') {
    return <IntegrityInformation shipInfo={shipInfo}></IntegrityInformation>;
  } else if (tab === 'register') {
    return <RegisterInformation shipInfo={shipInfo}></RegisterInformation>;
  } else if (tab === 'advancedVessel') {
    return (
      <AdvancedVesselInformation
        shipInfo={shipInfo}
      ></AdvancedVesselInformation>
    );
  } else if (tab === 'nextPort') {
    return <NextPortPanel shipInfo={shipInfo}></NextPortPanel>;
  }
  return null;
};

// Component for detail view - no map hooks
const DetailViewShipDetailsPanel = ({ shipInfo, tab }: ShipComponentProps) => {
  if (tab === 'base') {
    return <BaseInformation shipInfo={shipInfo} />;
  } else if (tab === 'integrity') {
    return <IntegrityInformation shipInfo={shipInfo}></IntegrityInformation>;
  } else if (tab === 'register') {
    return <RegisterInformation shipInfo={shipInfo}></RegisterInformation>;
  } else if (tab === 'advancedVessel') {
    return (
      <AdvancedVesselInformation
        shipInfo={shipInfo}
      ></AdvancedVesselInformation>
    );
  } else if (tab === 'nextPort') {
    return <NextPortPanel shipInfo={shipInfo}></NextPortPanel>;
  }
  return null;
};

export const ShipDetailsPanel = ({ shipInfo, tab }: ShipComponentProps) => {
  const { viewMode } = useViewMode();

  // Check if we're in detail view mode (no map available)
  const isDetailView = viewMode === ViewMode.Detail;

  // Conditionally render different components to avoid calling map hooks in detail view
  if (isDetailView) {
    return <DetailViewShipDetailsPanel shipInfo={shipInfo} tab={tab} />;
  } else {
    return <MapViewShipDetailsPanel shipInfo={shipInfo} tab={tab} />;
  }
};
